/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationReasonWarning } from './ApplicationReasonWarning'
import {
  ApplicationReasonWarningFromJSON,
  ApplicationReasonWarningFromJSONTyped,
  ApplicationReasonWarningToJSON,
} from './ApplicationReasonWarning'
import type { MktuClassShort } from './MktuClassShort'
import {
  MktuClassShortFromJSON,
  MktuClassShortFromJSONTyped,
  MktuClassShortToJSON,
} from './MktuClassShort'
import type { ApplicationType } from './ApplicationType'
import {
  ApplicationTypeFromJSON,
  ApplicationTypeFromJSONTyped,
  ApplicationTypeToJSON,
} from './ApplicationType'
import type { ApplicationResultStatus } from './ApplicationResultStatus'
import {
  ApplicationResultStatusFromJSON,
  ApplicationResultStatusFromJSONTyped,
  ApplicationResultStatusToJSON,
} from './ApplicationResultStatus'
import type { OwnerType } from './OwnerType'
import {
  OwnerTypeFromJSON,
  OwnerTypeFromJSONTyped,
  OwnerTypeToJSON,
} from './OwnerType'
import type { ApplicationStatus } from './ApplicationStatus'
import {
  ApplicationStatusFromJSON,
  ApplicationStatusFromJSONTyped,
  ApplicationStatusToJSON,
} from './ApplicationStatus'

/**
 *
 * @export
 * @interface ApplicationListItem
 */
export interface ApplicationListItem {
  /**
   *
   * @type {number}
   * @memberof ApplicationListItem
   */
  applicationNumber: number
  /**
   *
   * @type {ApplicationType}
   * @memberof ApplicationListItem
   */
  applicationType: ApplicationType
  /**
   *
   * @type {ApplicationStatus}
   * @memberof ApplicationListItem
   */
  filterStatus: ApplicationStatus
  /**
   * Порядковый номер заявления в системе
   * @type {number}
   * @memberof ApplicationListItem
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ApplicationListItem
   */
  imageUrl?: string
  /**
   *
   * @type {Array<MktuClassShort>}
   * @memberof ApplicationListItem
   */
  mktuClasses: Array<MktuClassShort>
  /**
   *
   * @type {string}
   * @memberof ApplicationListItem
   */
  name: string
  /**
   *
   * @type {OwnerType}
   * @memberof ApplicationListItem
   */
  ownerType: OwnerType
  /**
   *
   * @type {boolean}
   * @memberof ApplicationListItem
   */
  published: boolean
  /**
   *
   * @type {ApplicationResultStatus}
   * @memberof ApplicationListItem
   */
  resultStatus?: ApplicationResultStatus | null
  /**
   *
   * @type {string}
   * @memberof ApplicationListItem
   */
  rightholder?: string
  /**
   *
   * @type {string}
   * @memberof ApplicationListItem
   */
  rightholderAddress: string
  /**
   *
   * @type {string}
   * @memberof ApplicationListItem
   */
  applicationName: string
  /**
   *
   * @type {ApplicationReasonWarning}
   * @memberof ApplicationListItem
   */
  reason?: ApplicationReasonWarning | null
  /**
   *
   * @type {string}
   * @memberof ApplicationListItem
   */
  uuid: string
}

/**
 * Check if a given object implements the ApplicationListItem interface.
 */
export function instanceOfApplicationListItem(
  value: object
): value is ApplicationListItem {
  if (
    !('applicationNumber' in value) ||
    value['applicationNumber'] === undefined
  )
    return false
  if (!('applicationType' in value) || value['applicationType'] === undefined)
    return false
  if (!('filterStatus' in value) || value['filterStatus'] === undefined)
    return false
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('mktuClasses' in value) || value['mktuClasses'] === undefined)
    return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('ownerType' in value) || value['ownerType'] === undefined) return false
  if (!('published' in value) || value['published'] === undefined) return false
  if (
    !('rightholderAddress' in value) ||
    value['rightholderAddress'] === undefined
  )
    return false
  if (!('applicationName' in value) || value['applicationName'] === undefined)
    return false
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  return true
}

export function ApplicationListItemFromJSON(json: any): ApplicationListItem {
  return ApplicationListItemFromJSONTyped(json, false)
}

export function ApplicationListItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationListItem {
  if (json == null) {
    return json
  }
  return {
    applicationNumber: json['applicationNumber'],
    applicationType: ApplicationTypeFromJSON(json['applicationType']),
    filterStatus: ApplicationStatusFromJSON(json['filterStatus']),
    id: json['id'],
    imageUrl: json['imageUrl'] == null ? undefined : json['imageUrl'],
    mktuClasses: (json['mktuClasses'] as Array<any>).map(
      MktuClassShortFromJSON
    ),
    name: json['name'],
    ownerType: OwnerTypeFromJSON(json['ownerType']),
    published: json['published'],
    resultStatus:
      json['resultStatus'] == null
        ? undefined
        : ApplicationResultStatusFromJSON(json['resultStatus']),
    rightholder: json['rightholder'] == null ? undefined : json['rightholder'],
    rightholderAddress: json['rightholderAddress'],
    applicationName: json['applicationName'],
    reason:
      json['reason'] == null
        ? undefined
        : ApplicationReasonWarningFromJSON(json['reason']),
    uuid: json['uuid'],
  }
}

export function ApplicationListItemToJSON(
  value?: ApplicationListItem | null
): any {
  if (value == null) {
    return value
  }
  return {
    applicationNumber: value['applicationNumber'],
    applicationType: ApplicationTypeToJSON(value['applicationType']),
    filterStatus: ApplicationStatusToJSON(value['filterStatus']),
    id: value['id'],
    imageUrl: value['imageUrl'],
    mktuClasses: (value['mktuClasses'] as Array<any>).map(MktuClassShortToJSON),
    name: value['name'],
    ownerType: OwnerTypeToJSON(value['ownerType']),
    published: value['published'],
    resultStatus: ApplicationResultStatusToJSON(value['resultStatus']),
    rightholder: value['rightholder'],
    rightholderAddress: value['rightholderAddress'],
    applicationName: value['applicationName'],
    reason: ApplicationReasonWarningToJSON(value['reason']),
    uuid: value['uuid'],
  }
}
